
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useAdmin } from "@/hooks/useAdmin";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
  const { user, isLoading: authLoading } = useAuth();
  const { isAdmin, isLoading: adminLoading } = useAdmin();
  const location = useLocation();

  console.log('ProtectedRoute:', { 
    user: user?.id, 
    requireAdmin, 
    isAdmin, 
    authLoading, 
    adminLoading,
    pathname: location.pathname 
  });

  // 如果認證或管理員狀態還在載入中
  if (authLoading || (requireAdmin && adminLoading)) {
    console.log('ProtectedRoute: Loading...');
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // 如果用戶未登入，重定向到登入頁面
  if (!user) {
    console.log('ProtectedRoute: User not logged in, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果需要管理員權限但用戶不是管理員
  if (requireAdmin && !isAdmin) {
    console.log('ProtectedRoute: User is not admin, redirecting to home');
    return <Navigate to="/" replace />;
  }

  console.log('ProtectedRoute: Access granted');
  return <>{children}</>;
};

export default ProtectedRoute;
